const initial = {
  data: {},
  status: {},
  update: false,
  lastUpdate: null,
  expanded: false,
}

const initialStatus = {
  loading: false,
  success: false,
  error: false,
  data: null,
  message: null,
}

const metricsReducer = (state = initial, action) => {
  switch (action.type) {
    case 'RESET_METRICS_OBJ':
      return {}
    case 'RESET_METRICS_STATUS':
      return {
        ...state,
        status: {
          ...state.status,
          [action.payload]: initialStatus,
        },
      }
    case 'METRICS_ERROR':
      return {
        ...state,
        status: {
          ...state?.status,
          [action?.payload?.action]: {
            ...initialStatus,
            error: true,
            message: action?.payload?.message,
          },
        },
      }
    case 'GET_METRICS': {
      return {
        ...state,
        status: {
          ...state.status,
          get_metrics: {
            ...initialStatus,
            loading: true,
          },
        },
      }
    }
    case 'SET_METRICS': {
      return {
        ...state,
        data: action?.payload,
        status: {
          ...state.status,
          get_metrics: {
            ...initialStatus,
            success: true,
          },
        },
        lastUpdate: Date.now(),
      }
    }
    case 'UPDATE_METRICS': {
      return {
        ...state,
        update: action.payload,
      }
    }
    case 'EXPANDED_METRICS_AREA': {
      return {
        ...state,
        expanded: action.payload.expanded,
      }
    }
    default:
      return state
  }
}

export default metricsReducer
